import { render, staticRenderFns } from "./ShowFile.vue?vue&type=template&id=9b3bb5ae&scoped=true&"
import script from "./ShowFile.vue?vue&type=script&lang=js&"
export * from "./ShowFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3bb5ae",
  null
  
)

export default component.exports